// ============================================================================
// MEAL FORECAST SERVICE (buffet check-off slice 4)
// ============================================================================
// Backend: MealForecastController — the meal covers forecast (the same one the
// mobile Meals tab shows) and the unused package meals report. Read-only.

import { get } from '../client/axiosClient';
import { buildEndpoint } from '../endpoints/base.endpoints';
import type { ApiResponse } from '../types';
import type { MealForecast, UnusedMealReport } from '../types/mealForecast.types';

const BASE = '/MealForecast';

const unwrap = <T>(r: { data?: ApiResponse<T> }, fallback: string): T => {
  if (!r.data?.data) throw new Error(r.data?.message || fallback);
  return r.data.data;
};

export const mealForecastService = {
  /** Covers per date and meal; no fromDate = the property's business date. Days 1–30. */
  async getForecast(propertyId: string, fromDate: string | null, days: number): Promise<MealForecast> {
    return unwrap(await get<ApiResponse<MealForecast>>(buildEndpoint(BASE), {
      params: { propertyId, days, ...(fromDate ? { fromDate } : {}) },
    }), 'The meal forecast did not load.');
  },
  /** Plan meals not taken over past dates (capped at the day before the business date). */
  async getUnused(propertyId: string, from: string, to: string): Promise<UnusedMealReport> {
    return unwrap(await get<ApiResponse<UnusedMealReport>>(buildEndpoint(`${BASE}/unused`), { params: { propertyId, from, to } }),
      'The unused package meals did not load.');
  },
};
